<template>
  <div class="page-content">
    <page-breadcrumb title="Career list" class="mb-2" />

    <data-table-ssr id="item_list" ref="item_list"
      :create-row-fn="createItem" :create_schema="create_schema" :item_default_data="{
        name: { type: 'translatable-text', translations: [] }
      }"
      :get-list-fn="getList" :columns="item_fields"
      :to-edit-fn="toEditPage"
      :delete-row-fn="deleteItem"
    />
  </div>
</template>

<script>
import { removeEmpty } from '@core/utils/index'
import service from '../service'
const create_schema = [
  {
    cols: 12,
    fields: [
      { label: 'Key', field: 'key', input_type: 'text', validate: { required: true }, },
      { label: 'Name', field: 'name', input_type: 'ui-component' },
    ]
  }
];
const update_schema = [
  {
    cols: 12,
    fields: [
      { label: 'Name', field: 'name', input_type: 'ui-component' },
    ]
  }
];;

const item_fields = [
  { label: 'Key', field: 'key' },
  { label: 'Name', field: 'name', display_type: 'translatable-text' },
];

export default {
  data(){
    return{
      create_schema, update_schema,
      item_fields,
      total: 0,
    }
  },
  methods:{
    async createItem(data) {
      let new_item = await service.create(data);
      return new_item;
    },
    async getList({ limit, page, query }) {
      query = removeEmpty(query);
      let response = await service.getList({
        query: encodeURIComponent(JSON.stringify(query)),
        page,
        limit,
      });
      let list = []; let total = 0;
      if (response.data.type === "DATA") {
        list = response.data.data.list;
        total = response.data.data.total;
      }
      return { list, total }
    },
    async updateItem(row) {
      await service.update({ data: JSON.stringify(row) });
      // this.$refs.item_list.getList();
    },
    async toEditPage({ _id }) {
      this.$router.push({ name: 'ai_career-detail', params: { id: _id } });
    },
    async deleteItem({ _id }) {
      await service.delete({ id: _id });
    },
  }
}
</script>
